import { useMemo } from "react";
import { TENANT_FEATURE } from "@/constants/tenant-feature-constant";
import {
  INTAKE_FORM_SECTIONS,
  IntakeFormSection,
} from "@/pages/app/provider/scheduling/appointment/appointment-constant";
import { useTenantFeatures } from "./use-tenant-features";

/** Intake/consent forms the current tenant may send: Premier MD realms get only their own. */
export const usePatientFormOptions = (): IntakeFormSection[] => {
  const { pickExclusive } = useTenantFeatures();

  return useMemo(
    () =>
      pickExclusive(
        INTAKE_FORM_SECTIONS,
        TENANT_FEATURE.PREMIER_MD_CONSENT_FORMS
      ),
    [pickExclusive]
  );
};
